import script from "./LanguageDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageDropdown.vue?vue&type=script&setup=true&lang=js"

import "./LanguageDropdown.vue?vue&type=style&index=0&id=4886d06c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4886d06c"]])

export default __exports__